import React from "react";
import StudentSidebar from "../components/studentsidebar";
import Navbar from "../components/studentnavbar";
import {useSidebar } from "../components/SidebarContext"

const CompletedTests = () => {
  const { isSidebarOpen } = useSidebar();
    const sidebarWidth = isSidebarOpen ? '15.6rem' : '4.4rem';
  const tests = [
    {
      _id: "1",
      testName: "Math Final Exam",
      overallPercentage: 85,
      grade: "A",
    },
    {
      _id: "2",
      testName: "Science Quiz",
      overallPercentage: 72,
      grade: "B",
    },
    {
      _id: "3",
      testName: "English Test",
      overallPercentage: 63,
      grade: "C",
    },
  ];

  // Inline styles for container and table
  const containerStyle = {
    minHeight: "100vh",
    backgroundColor: "white",
    position: "relative"
  };

  const sidebarStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    height: "100%",
    width: "284px",
    backgroundColor: "#121826",
    zIndex: 10
  };

  const contentStyle = {
    marginLeft: "284px",
    padding: "32px"
  };

  const contentContainerStyle = {
    maxWidth: "1100px",
    margin: "0 auto"
  };

  const headerContainerStyle = {
    display: "flex",
    alignItems: "center",
    marginBottom: "24px"
  };

  const iconContainerStyle = {
    backgroundColor: "#e6f0ff",
    padding: "8px",
    borderRadius: "8px",
    marginRight: "16px"
  };

  const titleStyle = {
    fontSize: "28px",
    fontWeight: "bold",
    color: "#1a56db"
  };

  const tableContainerStyle = {
    overflowX: "auto",
    width: "100%"
  };

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse"
  };

  const thStyle = {
    padding: "16px",
    textAlign: "left",
    fontWeight: "600",
    color: "#1f2937",
    border: "1px solid #c9dafb",
    backgroundColor: "#e6f0ff"
  };

  const tdStyle = {
    padding: "16px",
    border: "1px solid #e5e7eb"
  };

  const tdStyleAlt = {
    ...tdStyle,
    backgroundColor: "#f9fafb"
  };

  const emptyMessageStyle = {
    color: "#6b7280",
    marginTop: "24px",
    textAlign: "center",
    fontSize: "20px"
  };

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f0f4f8", display: "flex" }}>
      {/* Sidebar */}
      <div style={{ position: "fixed", top: 0, left: 0, height: "100%", width: "250px", zIndex: 10 }}>
        <StudentSidebar />
      </div>

      {/* Navbar */}
      <Navbar />

      {/* Main content area */}
      <div style={{  marginLeft: sidebarWidth,
          width: `calc(100% - ${sidebarWidth})`, marginTop: "55px", transition: 'all 0.3s ease', }}>
        <div style={contentContainerStyle}>
          {/* Header with icon and title */}
          <div style={headerContainerStyle}>
            <div style={iconContainerStyle}>
              <span style={{ color: "#3b82f6", fontSize: "24px" }}>📊</span>
            </div>
            <h1 style={titleStyle}>Completed Tests</h1>
          </div>

          {/* Table with light blue header and alternating rows */}
          <div style={tableContainerStyle}>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thStyle}>Sr. No.</th>
                  <th style={thStyle}>Test Name</th>
                  <th style={thStyle}>Overall %</th>
                  <th style={thStyle}>Grade</th>
                </tr>
              </thead>
              <tbody>
                {tests.map((test, index) => (
                  <tr key={test._id}>
                    <td style={index % 2 === 0 ? tdStyle : tdStyleAlt}>{index + 1}</td>
                    <td style={index % 2 === 0 ? tdStyle : tdStyleAlt}>{test.testName}</td>
                    <td style={index % 2 === 0 ? tdStyle : tdStyleAlt}>{test.overallPercentage}%</td>
                    <td style={index % 2 === 0 ? tdStyle : tdStyleAlt}>{test.grade}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            {tests.length === 0 && (
              <p style={emptyMessageStyle}>
                No completed tests available.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompletedTests;